import { bigQuery, mixpanel } from '@fiverr-private/obs';
import { EVENTS, EVENT_TYPES } from './constants';

/**
 * Tracks a given event to mixpanel
 * @param {String} event The event name to report.
 * @param {String} sourceComponent The source component this event was triggered from.
 */
const trackMixpanel = (event, sourceComponent) => mixpanel.track(event, {
    'Source Component': sourceComponent,
    'View Type': 'Pop-up'
});

/**
 * Tracks a given event to bigquery.
 * @param {String} event The event name to report.
 */
const trackBigQueryEvent = (event) => bigQuery.send({
    type: event,
    group: 'signin flow'
});

/**
 * Tracks a user session event type.
 * @param {String} eventType The internal event type (One of EVENT_TYPES)
 * @param {String} customBigQueryEvent The custom event to sent to big query additional to the default one.
 * @param {String} sourceComponent The source component which triggered the event.
 */
const trackEvent = ({ eventType, customBigQueryEvent, sourceComponent }) => {
    const platforms = EVENTS[eventType];

    trackMixpanel(platforms.mixpanel, sourceComponent);
    trackBigQueryEvent(platforms.bigQuery);

    // Allow customer to extends the default event with custom one.
    customBigQueryEvent && trackBigQueryEvent(customBigQueryEvent);
};

export {
    EVENT_TYPES,
    trackEvent
};
